<template>
  <div class="container-fluid autenticacao">
    <div>
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col col-xs-2">
              <h5 class="panel-title">Consultar NFSe por RPS</h5>
            </div>
          </div>
        </div>
        <div id="topo" class="card-body">
          <div class="form-title-links">
            <span
              class="form-title"
            >Verifique se sua RPS ja esta convertida em Nfse</span>
          </div>

          <div class="p-field-radiobutton">
            <RadioButton
              id="radio1"
              name="documento"
              value="R"
              v-model="tipoValidacao"
              class="radio"
              tabindex="1"
            />
            <label for="radio1" class="p-radiobutton-label">Número RPS</label>

            <RadioButton
              id="radio2"
              name="chave"
              value="L"
              v-model="tipoValidacao"
              class="radio2"
              tabindex="2"
            />
            <label for="radio2" class="p-radiobutton-label">Número Lote RPS</label>
          </div>
          <br />
          <br />

          <InputText
            id="cpfCnpjPrestador"
            type="text"
            @blur="validarDocumento()"
            placeholder="CPF/CNPJ do prestador *"
            autocomplete="off"
            tabindex="3"
            class="inputLogin"
            v-model="documentoPrestador"
          />
          <br />
          <br />
          <InputText
            id="inscMunicPrestador"
            type="text"
            placeholder="Inscrição Municipal do prestador"
            autocomplete="off"
            tabindex="4"
            class="inputLogin"
            maxlength="40"
            v-model="inscricaoPrestador"
          />
          <br />
          <br />

          <InputText
            id="cpfCnpjTomador"
            type="text"
            @blur="validarDocumentoTomador()"
            placeholder="CPF/CNPJ do tomador *"
            autocomplete="off"
            tabindex="5"
            class="inputLogin"
            v-model="documentoTomador"
          />
          <br />
          <br />
          <InputText
            id="numero"
            type="text"
            placeholder="Número *"
            autocomplete="off"
            tabindex="6"
            maxlength="20"
            class="inputLogin"
            v-model="numero"
          />

          <br />
          <br />
          <InputText
            id="Série RPS"
            type="text"
            placeholder="Série RPS"
            autocomplete="off"
            tabindex="6"
            maxlength="20"
            class="inputLogin"
            v-model="serie"
          />

          <br />
          <br />
          <InputText
            id="Tipo RPS"
            type="text"
            placeholder="Tipo RPS"
            autocomplete="off"
            tabindex="6"
            maxlength="20"
            class="inputLogin"
            v-model="tipoRps"
          />

          <div class="botoes-avancar-voltar" style="margin-top: 15px;">
            <Button label="Voltar" type="submit"  class="btnVoltar" id="btnVoltar" @click="login()"  icon="pi pi-angle-left" :disabled="loading" />
            <Button label="Consultar" type="submit"  class="btnAvançar" id="btnAutenticar" @click="consultar()" icon="pi pi-angle-right" :disabled="loading" />
          </div>
        </div>
        <Dialog
            class="test-box"
            header="Informação"
            :visible.sync="showDialog"
            :modal="true"
            :closable="false"
          >
            <div class="container">
              <div id="topo" class="row">
                <div class="col-md-12 mb-2">
                  <label for="tipoTomador">Rps convertida em Nota Fiscal, deseja realizar a impressão?</label>
                </div>
              </div>
            </div>

            <hr />

            <div class="container">
              <div class="row">
                <div>
                  <Button
                    @click="visualizarNfse()"
                    href="#topo"
                    type="button"
                    label="Sim"
                    class="p-button-primary mr-2 p-button-success"
                    icon="pi pi-check"
                    :disabled="loading"
                  />
                </div>

                <div>
                  <Button
                    @click="showDialog = false"
                    type="button"
                    label="Não"
                    class="p-button-primary mr-2 p-button-danger"
                    icon="pi pi-times"
                  />
                </div>
              </div>
            </div>
          </Dialog>
      </div>
    </div>
  </div>
</template>

<script>
import AutenticacaoService from "../services/nfse/autenticacao.service";
import DnsClienteService from "../services/nfse/dns.cliente.service";
import Util from "../Utils/util";

export default {
  data() {
    return {
      documentoPrestador: '',
      inscricaoPrestador: '',
      documentoTomador: '',
      numero: '',
      serie: '',
      tipoRps: '',
      tipoValidacao: null,
      loading: false,
      idCliente: null,
      anoAtual: null,
      showDialog: false,
      notaFiscalId: null
    };
  },

  mounted() {
    document.getElementById("cpfCnpjPrestador").focus();
    var d = new Date();
    this.anoAtual = d.getFullYear();
    setTimeout(async () => {
      this.processando(true);
      let host = window.location.hostname;
      this.dnsCliente = await DnsClienteService.get(host);
      if (
        this.dnsCliente &&
        this.dnsCliente.data &&
        this.dnsCliente.data.idCliente
      ) {
        this.idCliente = this.dnsCliente.data.idCliente;
      }
      this.processando(false);
    }, 250);
  },

  created() {
    this.limparDados();
  },

  methods: {
    limparDados() {
      this.documentoPrestador = '';
      this.inscricaoPrestador = '';
      this.documentoTomador = '';
      this.numero = '';
      this.serie = '';
      this.tipoRps = '';
      this.tipoValidacao = "R";
      this.loading = false;
      this.notaFiscalId = null;
    },

    login() {
      this.$router.push("/login");
    },

    consultar() {
      this.processando(true);
      if (
        this.documentoPrestador &&
        this.documentoTomador &&
        this.numero &&
        this.tipoValidacao &&
        this.idCliente
      ) {
        AutenticacaoService.consultarRps(
          this.tipoValidacao,
          this.documentoPrestador.trim(),
          (this.inscricaoPrestador != null  ? this.inscricaoPrestador.trim() : null),
          this.documentoTomador.trim(),
          this.numero.trim(),
          this.serie.trim(),
          this.tipoRps.trim(),
          this.idCliente
        ).then(
            response => {
              this.notaFiscalId = response.data;
              console.log(this.notaFiscalId);
              this.showDialog = true;
              
            },
            error => {
              this.$root.$emit("alert:error", error.response.data);
            }
          ).then(() => {
            this.processando(false);
          });
      }else{
        this.$root.$emit("alert:warn", "Preencha os campos obrigatórios!");
        this.processando(false);
      }
    },

    visualizarNfse() {
      this.processando(true);
      if (
        this.notaFiscalId
      ) {
        AutenticacaoService.visualisarNfse(
          this.notaFiscalId
        )
          .then(
            () => {this.showDialog = false;},
            error => {
              this.$root.$emit("alert:warn", "Erro ao exibir a visualização!");
              console.log(error);
            }
          )
          .then(() => {
            this.processando(false);
          });
      }
    },

    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit("loading:show");
      } else {
        this.loading = false;
        this.$root.$emit("loading:hide");
      }
    },

    validarDocumento() {
      var validar = false;
      validar = Util.validarCPFCNPJ(this.documentoPrestador);

      if (!validar && this.documentoPrestador) {
        console.log(validar);
        this.documentoPrestador = '';
        this.$root.$emit("alert:error", "CPF/CNPJ Prestador inválido!");
      }
    },
    validarDocumentoTomador() {
      var validar = false;
      validar = Util.validarCPFCNPJ(this.documentoTomador);

      if (!validar && this.documentoTomador) {
        console.log(validar);
        this.documentoTomador = '';
        this.$root.$emit("alert:error", "CPF/CNPJ Tomador inválido!");
      }
    }
  }
};
</script>

<style src="../assets/css/links-autenticacao-recibo-credenciamento-contribuintes.css"></style>